export const DEFAULT_PROFILE_IMAGE = '/images/profile-placeholder.png';
